angular.module('tf.controllers')

    .controller('DocumentationController', ['$scope','HeaderService','AuthService',
        function ($scope,HeaderService, AuthService){
            //HeaderService.setName('Documentation');
            $scope.isLoggedIn = AuthService.isAuthenticated;
        }]);